import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5affd25d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 letter-spacing" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "row g-3 mb-3" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Organes", -1))
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mandature", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Postes", -1))
const _hoisted_11 = { class: "row g-3" }
const _hoisted_12 = { class: "card p-3" }
const _hoisted_13 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mb-2" }
const _hoisted_17 = { class: "small text-muted" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_21 = ["id"]
const _hoisted_22 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"max-width":"600px"}
}
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header justify-content-center text-center border-0" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Ajouter un membre"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal"
  })
], -1))
const _hoisted_25 = { class: "modal-body" }
const _hoisted_26 = { class: "row justify-content-center" }
const _hoisted_27 = { class: "col-md-8 mb-3" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Nom", -1))
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { class: "col-md-8 mb-3" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Prénom", -1))
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "col-md-8 mb-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Image", -1))
const _hoisted_35 = ["onChange"]
const _hoisted_36 = { class: "modal-footer justify-content-center" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, "Annuler", -1))
const _hoisted_39 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_40 = { class: "mt-4" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, "Modifier assignations - " + _toDisplayString(_ctx.organeNom || ""), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Multiselect, {
            options: _ctx.organesOptions,
            modelValue: _ctx.selectedOrganeId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedOrganeId) = $event)),
            "track-by": "value",
            label: "label",
            searchable: true,
            onInput: _ctx.onOrganeSelect,
            disabled: !!_ctx.isEditMode
          }, null, 8, ["options", "modelValue", "onInput", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Multiselect, {
            options: _ctx.mandaturesOptions,
            modelValue: _ctx.selectedMandatureId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedMandatureId) = $event)),
            "track-by": "value",
            label: "label",
            searchable: true,
            onInput: _ctx.onMandatureSelect
          }, null, 8, ["options", "modelValue", "onInput"])
        ])
      ]),
      (_ctx.postes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postes, (poste) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md-6",
                  key: poste.id
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(poste.numeroOrdre) + " - " + _toDisplayString(poste.nomPoste), 1),
                        (poste.arrondissement?.libelle)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " (" + _toDisplayString(poste.arrondissement.libelle) + ") ", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-warning",
                        type: "button",
                        onClick: ($event: any) => (_ctx.openAddMemberModal(poste.id))
                      }, " Ajouter+ ", 8, _hoisted_15)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Multiselect, {
                        options: _ctx.membresOptions,
                        modelValue: poste.selectedMembre,
                        "onUpdate:modelValue": ($event: any) => ((poste.selectedMembre) = $event),
                        "track-by": "value",
                        label: "label",
                        searchable: true,
                        placeholder: "Sélectionner un membre ou ajouter"
                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (poste.selectedMembre && poste.selectedMembre > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Membre existant sélectionné "))
                        : (poste.selectedMembre && poste.selectedMembre < 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Nouveau membre temporaire : " + _toDisplayString(poste.membre.nom) + " " + _toDisplayString(poste.membre.prenom), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, "Aucun membre"))
                    ]),
                    _createElementVNode("div", {
                      class: "modal fade",
                      id: `modal_add_${poste.id}`,
                      tabindex: "-2",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((poste.membre.nom) = $event)
                                }, null, 8, _hoisted_29), [
                                  [_vModelText, poste.membre.nom]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((poste.membre.prenom) = $event)
                                }, null, 8, _hoisted_32), [
                                  [_vModelText, poste.membre.prenom]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("input", {
                                  type: "file",
                                  class: "form-control",
                                  onChange: e => _ctx.onImageChange(poste, e)
                                }, null, 40, _hoisted_35)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary",
                              onClick: ($event: any) => (_ctx.confirmAddMember(poste)),
                              "data-bs-dismiss": "modal"
                            }, "Ajouter", 8, _hoisted_37),
                            _hoisted_38
                          ])
                        ])
                      ])
                    ], 8, _hoisted_21)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_39, "Aucun poste pour cet organe")),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("button", {
          class: "btn btn-success me-2",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateAssign && _ctx.updateAssign(...args))),
          disabled: _ctx.loading
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_42, "Enregistrement…"))
            : (_openBlock(), _createElementBlock("span", _hoisted_43, "Enregistrer les modifications"))
        ], 8, _hoisted_41),
        _createVNode(_component_router_link, {
          to: "/liste-assignation",
          class: "btn btn-secondary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Annuler")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}